import { Spin, Tabs } from "antd";
import ListProgress from "./listProgress";
import { useEffect, useState } from "react";
import { useReport } from "../../../tools/api";

// EP = package (بسته), DC = charge (شارژ); the SIM tab has three services, each shown under its own title
const TABS = [
	{
		key: "sim",
		label: "سیم کارت",
		groups: (r) => [
			{ title: "فروش سیم‌کارت", load: r.sPSalesPerState },
			{ title: "تعویض سیم‌کارت", load: r.swSalesPerState },
			{ title: "انتقال مالکیت", load: r.coSalesPerState },
		],
	},
	{ key: "ep", label: "بسته", groups: (r) => [{ load: r.ePSalesPerState }] },
	{ key: "dc", label: "شارژ", groups: (r) => [{ load: r.dCSalesPerState }] },
];

const InProgress = () => {
	const report = useReport();
	const [groups, setGroups] = useState([]);
	const [activeTab, setActiveTab] = useState(TABS[0].key);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let cancelled = false;
		const initialServ = async () => {
			setLoading(true);
			const tab = TABS.find((t) => t.key === activeTab);
			const defs = tab.groups(report);
			const responses = await Promise.all(defs.map((g) => g.load()));
			if (cancelled) return;
			setGroups(
				defs
					.map((g, i) => ({ title: g.title, rows: responses[i] && !responses[i].HasError ? responses[i].Result || [] : [] }))
					.filter((g) => g.rows.length),
			);
			setLoading(false);
		};
		initialServ();
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab]);

	return (
		<section className="dash-card dash-progress" aria-labelledby="progress-title">
			<header className="dash-card-head">
				<h2 id="progress-title">گزارش عملکرد</h2>
			</header>
			<Tabs
				className="tab-report"
				activeKey={activeTab}
				onChange={setActiveTab}
				items={TABS.map((t) => ({
					key: t.key,
					label: t.label,
					children: loading ? (
						<div className="dash-loading">
							<Spin />
						</div>
					) : (
						<ListProgress groups={groups} />
					),
				}))}
			/>
		</section>
	);
};

export default InProgress;
